export * from './layout';
export const frontendCurrency = 'Kč';
